<template>
<div class="bg-w p-20">
  <tk-flex between>
    <div class="font-20 font-bold">{{ name }}</div>
    <a-button :loading="loading" type="primary" @click="save">保存</a-button>
  </tk-flex>
  <ak-permissions v-model="permissions" />
</div>
</template>
<script>
export default {
  data () {
    return {
      loading: false,
      name: '',
      permissions: []
    }
  },
  computed: {
    levelId () {
      return this.$route.query.id
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      const res = await this.$tkParse.get(`/classes/hierarchy/${this.levelId}`)
      this.name = res.data.name
      this.permissions = res.data.permissions || []
    },
    async save () {
      this.loading = true
      try {
        await this.$tkParse.put(`/classes/hierarchy/${this.levelId}`, {
          permissions: this.permissions
        })
        this.$notification['success']({
          message: '操作成功',
          description: '数据保存成功'
        })
      } catch (e) {
        this.$notification['error']({
          message: '操作失败',
          description: '操作失败，请重试'
        })
      }
      this.loading = false
    }
  }
}
</script>
<style>
</style>
